import BlSelectionBlockMv from './BlSelectionBlockMv.vue'

BlSelectionBlockMv.install = function(Vue) {
  Vue.component(BlSelectionBlockMv.name, BlSelectionBlockMv)
}

export default BlSelectionBlockMv
